module.exports = __webpack_public_path__ + "static/media/hrbp_fw1.f2e6d70f.jpg";